var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot_lemontree",attrs:{"id":"lemontreeFoor"}},[_vm._v(" CopyRight © Lemontree 2021.All rights reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }